import React from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Theme } from "../../theme";
import getAxios from "../../hooks/useAxios";
import Cookies from "js-cookie";
import {
  Box,
  useTheme,
  Text,
  Button,
  Flex,
  Alert,
  AlertIcon,
} from "@chakra-ui/react";
import { FaArrowRight } from "react-icons/fa";
import Input from "../../components/CustomInput";

const ModifyAdmin = () => {
  let [searchParams] = useSearchParams();
  const theme = useTheme<Theme>();
  const navigate = useNavigate();

  const axios = getAxios();
  const access_token = Cookies.get("x-admin-auth");

  const [name, setName] = React.useState("");
  const [phone, setPhone] = React.useState("");
  const [updateStatus, setUpdateStatus] = React.useState("");

  const id = searchParams.get("id");

  const getAdminById = async () => {
    try {
      const res = await axios.get(`/admins/${id}`, {
        headers: {
          Authorization: `Bearer ${access_token}`,
        },
      });
      setName(res.data.name);
      setPhone(res.data.mobile);
    } catch (error) {
      console.log("error listing ad", error);
    }
  };

  React.useEffect(() => {
    getAdminById();
  }, []);

  const updateAdmin = async (e: React.BaseSyntheticEvent) => {
    e.preventDefault();
    const data = {
      mobile: phone,
      name: name,
      role: "admin",
    };
    try {
      const res = await axios.put(`/admins/${id}`, data, {
        headers: {
          Authorization: `Bearer ${access_token}`,
        },
      });
      setUpdateStatus("updated");
      console.log("submit", res);
      setTimeout(() => {
        navigate("/admin");
      }, 2000);
    } catch (error) {
      console.log("error", error);
      setUpdateStatus("error");
    }
  };
  return (
    <Box style={{ padding: "2rem" }}>
      <Text
        sx={{
          fontSize: theme.fontSizes.subHeading2,
          marginBottom: theme.space["3xl"],
        }}
      >
        Update Admin
      </Text>
      <Box
        style={{
          width: "50%",
          backgroundColor: "#FFFFFF",
          padding: "2rem",
          borderRadius: "8px",
        }}
      >
        <form onSubmit={updateAdmin}>
          <Flex flexDirection={"column"}>
            <label>Administrator Name:</label>

            <Input
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              name="name"
              placeholder="Admin name"
              variant={"outline"}
            />

            <label style={{ display: "block", marginTop: theme.space.xl }}>
              Administrator Phone Number:
            </label>
            <Input
              type="number"
              value={phone}
              maxLength={10}
              onChange={(e) => setPhone(e.target.value)}
              name="phone"
              placeholder="Admin phone"
              variant={"outline"}
            />

            <Box sx={{ marginTop: theme.space.xxl }}>
              <Button
                type="submit"
                width="100%"
                height="3rem"
                rightIcon={<FaArrowRight />}
                // isLoading={isLoginLoading ? true : false}
                style={{
                  background: theme.colors.primary.main,
                  color: theme.colors.bg.main,
                }}
              >
                <Text sx={{ fontSize: theme.fontSizes.body }}>Update</Text>
              </Button>
            </Box>

            <Box sx={{ minHeight: "3.25rem" }}>
              {updateStatus === "updated" && (
                <Alert status="success">
                  <AlertIcon />
                  Admin Updated successfully.
                </Alert>
              )}
              {updateStatus === "error" && (
                <Alert status="error" borderRadius={"4px"}>
                  <AlertIcon />
                  Opps! Something went wrong.
                </Alert>
              )}
            </Box>
          </Flex>
        </form>
      </Box>
    </Box>
  );
};

export default ModifyAdmin;
